import React from 'react';
import { Helmet } from 'react-helmet-async';

const Privacy = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>Privacy Policy - Data Protection & Information Sharing | Cargo Engage</title>
        <meta name="description" content="Cargo Engage privacy policy. Learn how we collect, use, and share information when connecting consumers with financial service providers. SMS consent not transferable." />
        <meta name="keywords" content="privacy policy, data protection, information sharing, SMS consent, TCPA compliance, consumer privacy" />
      </Helmet>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Privacy Policy</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic'}}>
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div style={{background: '#fff3cd', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ffc107'}}>
              <p style={{fontWeight: '600', color: '#856404', marginBottom: '0.5rem'}}>
                Important Disclosure:
              </p>
              <p style={{color: '#856404'}}>
                Cargo Engage is a lead generation and marketing company. We are NOT a lender and do NOT make credit decisions. 
                This privacy policy explains how we collect, use, and share information when connecting consumers with financial service providers.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Introduction</h2>
            <p style={{marginBottom: '2rem'}}>
              CARGO AUTOMOTIVE SERVICES INC, operating as Cargo Engage ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy 
              explains how we collect, use, disclose, and safeguard your information when you use our lead generation 
              services and visit our website at cargoengage.com.
            </p>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Information We Collect</h2>
            
            <h3 style={{color: '#374151', marginBottom: '0.5rem'}}>Personal Information</h3>
            <p style={{marginBottom: '1rem'}}>We may collect the following personal information:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Name and contact information (email, phone number, address)</li>
              <li>Financial service needs and preferences</li>
              <li>Information about your financial situation (for lead qualification)</li>
              <li>Communication preferences and consent records</li>
              <li>Device and browser information</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>How We Use Your Information</h2>
            <p style={{marginBottom: '1rem'}}>We use collected information for the following purposes:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Connecting you with appropriate financial service providers</li>
              <li>Qualifying and verifying lead information</li>
              <li>Communicating with you about financial services</li>
              <li>Sending marketing messages (with your consent)</li>
              <li>Improving our services and website</li>
              <li>Ensuring compliance with applicable laws and regulations</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Information Sharing</h2>
            <div style={{background: '#fef2f2', padding: '1.5rem', borderRadius: '8px', marginBottom: '1rem', border: '2px solid #ef4444'}}>
              <p style={{fontWeight: '600', color: '#dc2626', marginBottom: '0.5rem'}}>
                IMPORTANT - Lead Sharing Disclosure:
              </p>
              <p style={{color: '#dc2626', marginBottom: '0.5rem'}}>
                <strong>When you submit your information through our website, you authorize us to share your contact information 
                and inquiry details with our network of financial service providers and lending partners.</strong>
              </p>
              <p style={{color: '#dc2626'}}>
                Multiple companies may contact you about their financial products and services. This is the primary purpose 
                of our lead generation service.
              </p>
            </div>

            <div style={{background: '#fef2f2', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ef4444'}}>
              <p style={{fontWeight: '600', color: '#dc2626', marginBottom: '0.5rem'}}>
                MOBILE PHONE NUMBER PROTECTION (CTIA Required Statement):
              </p>
              <p style={{color: '#dc2626'}}>
                <strong>Your SMS consent is not transferable and will not be sold, shared, or rented to third parties for their own marketing purposes.</strong> 
                Only Cargo Engage and the specific lending partners we connect you with may send you text messages based on your consent.
              </p>
            </div>

            <p style={{marginBottom: '1rem'}}>We share information in the following circumstances:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>Financial Service Providers:</strong> We share your lead information with our network of lending partners</li>
              <li><strong>Service Providers:</strong> Technical vendors who assist in platform operations</li>
              <li><strong>Legal Requirements:</strong> When required by law, regulation, or legal process</li>
              <li><strong>Business Transfers:</strong> In connection with mergers, acquisitions, or asset sales</li>
              <li><strong>Consent:</strong> With your explicit consent for specific purposes</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Data Security</h2>
            <p style={{marginBottom: '1rem'}}>We implement comprehensive security measures:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Encryption of data in transit and at rest</li>
              <li>Secure data centers with access controls</li>
              <li>Regular security audits</li>
              <li>Employee training on data protection</li>
              <li>Multi-factor authentication</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Your Rights and Choices</h2>
            <p style={{marginBottom: '1rem'}}>You have the following rights:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>Access:</strong> Request access to your personal information</li>
              <li><strong>Correction:</strong> Request correction of inaccurate information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information</li>
              <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
              <li><strong>Consent Withdrawal:</strong> Withdraw consent for specific processing</li>
            </ul>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>SMS Marketing Consent</h2>
            <div style={{background: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <p style={{marginBottom: '1rem', fontWeight: '600', color: '#1e40af'}}>
                SMS Program Terms:
              </p>
              <p style={{marginBottom: '1rem'}}>
                By providing your phone number and consent, you agree to receive SMS messages from Cargo Engage and our lending partners. 
                <strong> Message frequency varies. Message and data rates may apply.</strong> Reply STOP to opt out.
              </p>
              <p style={{marginBottom: '0', fontSize: '0.95rem', color: '#1e40af', fontWeight: '600'}}>
                Required CTIA Disclosure: Your consent to receive SMS is not required as a condition of purchasing any goods or services, 
                and is not required to obtain credit. SMS consent is not transferable and will not be sold, shared, or rented to third parties.
              </p>
            </div>

            <h2 style={{color: '#1e3c72', marginBottom: '1rem'}}>Contact Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px'}}>
              <p><strong>CARGO AUTOMOTIVE SERVICES INC</strong></p>
              <p><strong>DBA:</strong> Cargo Engage</p>
              <p>306 Schunnemunk Street<br />Monroe, NY 10950<br />United States</p>
              <p><strong>Owner:</strong> Mendel Friedman</p>
              <p><strong>EIN:</strong> 83-2229681</p>
              <p style={{marginTop: '1rem'}}><strong>Email:</strong> privacy@cargoengage.com</p>
              <p><strong>Support:</strong> support@cargoengage.com</p>
              <p style={{marginTop: '1rem', fontSize: '0.9rem', color: '#6b7280'}}>
                For privacy-related inquiries, please email us or use our contact form.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
